export {default as CheckedInReminder} from './CheckedInReminder.connect';
